(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 1127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(2173);
// EXTERNAL MODULE: ./src/stitches/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(8325);
;// CONCATENATED MODULE: ./src/components/Footer/style.ts


var buttonPadding = 6;
var CopyrightNotice = (0,stitches_config/* styled */.zo)('span', {
  whiteSpace: 'nowrap'
});
var Footer = (0,stitches_config/* styled */.zo)('footer', {
  displayFlex: 'column',
  justifyContent: 'space-between',
  gap: stitches_config/* theme.space.lg */.rS.space.lg,
  borderTopWidth: stitches_config/* theme.borderWidths.thin */.rS.borderWidths.thin,
  borderTopStyle: stitches_config/* theme.borderStyles.normal */.rS.borderStyles.normal,
  borderTopColor: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  color: stitches_config/* theme.colors.textSecondary */.rS.colors.textSecondary,
  fontWeight: stitches_config/* theme.fontWeights.thin */.rS.fontWeights.thin,
  variants: {
    hasMargin: {
      "true": {
        marginTop: stitches_config/* theme.space.xxl */.rS.space.xxl
      }
    },
    mobile: {
      "true": {
        flexDirection: 'row',
        alignItems: 'center',
        paddingX: stitches_config/* theme.space.xl */.rS.space.xl,
        paddingY: stitches_config/* theme.space.lg */.rS.space.lg
      },
      "false": {
        padding: stitches_config/* theme.space.lg */.rS.space.lg
      }
    }
  }
});
var List = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  alignItems: 'center',
  gap: stitches_config/* theme.space.lg */.rS.space.lg
});
var ButtonsAndLinks = (0,stitches_config/* styled */.zo)(List, {
  justifyContent: 'space-between',
  width: '100%'
});
var SecondGroup = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.sm */.rS.space.sm,
  alignItems: 'center'
});
var IconLink = (0,stitches_config/* styled */.zo)(Link/* RouterLink */.r, {
  display: 'flex'
});
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(6556);
// EXTERNAL MODULE: ./src/components/Text/index.tsx + 1 modules
var Text = __webpack_require__(2762);
// EXTERNAL MODULE: ./src/stitches/switchTheme.ts + 1 modules
var switchTheme = __webpack_require__(7765);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ./src/svg/SvgDarkTheme.tsx



function SvgDarkTheme(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M15.22 6.03L17.75 4.09L14.56 4L13.5 1L12.44 4L9.25 4.09L11.78 6.03L10.87 9.09L13.5 7.28L16.13 9.09L15.22 6.03Z",
      fill: themeColor
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M19.61 12.25L21.25 11L19.19 10.95L18.5 9L17.81 10.95L15.75 11L17.39 12.25L16.8 14.23L18.5 13.06L20.2 14.23L19.61 12.25Z",
      fill: themeColor
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M6.47094 5.44867L6.5392 6.65167C6.6925 9.35355 7.80352 12.0462 9.88315 14.146C11.9638 16.1969 14.6471 17.3175 17.3582 17.4708L18.5616 17.5388L17.6634 18.3426C14.3261 21.3292 9.20497 21.2114 5.99703 18.0141L5.99586 18.013C2.79855 14.805 2.68083 9.68388 5.66741 6.34657L6.47094 5.44867Z",
      fill: themeColor
    })]
  });
}

/* harmony default export */ var svg_SvgDarkTheme = (SvgDarkTheme);
;// CONCATENATED MODULE: ./src/svg/SvgDiscord.tsx


function SvgDiscord(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M18.9308 5.26368C17.6561 4.67878 16.2892 4.24785 14.8599 4.00104C14.8339 3.99627 14.8079 4.00818 14.7945 4.03198C14.6187 4.34466 14.4239 4.75258 14.2876 5.0732C12.7503 4.84306 11.221 4.84306 9.71527 5.0732C9.57887 4.74545 9.37707 4.34466 9.20048 4.03198C9.18707 4.00897 9.16107 3.99707 9.13504 4.00104C7.70659 4.24706 6.33963 4.67799 5.06411 5.26368C5.05307 5.26844 5.04361 5.27638 5.03732 5.28669C2.44449 9.16033 1.73421 12.9387 2.08265 16.6703C2.08423 16.6886 2.09447 16.706 2.10867 16.7171C3.81934 17.9734 5.47642 18.7361 7.10273 19.2416C7.12876 19.2496 7.15634 19.24 7.1729 19.2186C7.55761 18.6933 7.90054 18.1393 8.19456 17.5568C8.21192 17.5227 8.19535 17.4822 8.15989 17.4687C7.61594 17.2624 7.098 17.0108 6.59977 16.7251C6.56037 16.7021 6.55721 16.6457 6.59347 16.6187C6.69831 16.5402 6.80318 16.4584 6.9033 16.3759C6.92141 16.3608 6.94665 16.3576 6.96794 16.3671C10.2411 17.8615 13.7846 17.8615 17.0191 16.3671C17.0404 16.3568 17.0657 16.36 17.0846 16.3751C17.1847 16.4576 17.2895 16.5402 17.3952 16.6187C17.4314 16.6457 17.4291 16.7021 17.3897 16.7251C16.8914 17.0163 16.3735 17.2624 15.8288 17.4679C15.7933 17.4814 15.7775 17.5227 15.7949 17.5568C16.0952 18.1385 16.4381 18.6924 16.8157 19.2178C16.8315 19.24 16.8599 19.2496 16.8859 19.2416C18.5201 18.7361 20.1772 17.9734 21.8879 16.7171C21.9028 16.706 21.9123 16.6894 21.9139 16.6711C22.3309 12.357 21.2154 8.60956 18.9568 5.28748C18.9513 5.27638 18.9419 5.26844 18.9308 5.26368ZM8.68335 14.3982C7.69792 14.3982 6.88594 13.4935 6.88594 12.3824C6.88594 11.2713 7.68217 10.3666 8.68335 10.3666C9.69239 10.3666 10.4965 11.2793 10.4807 12.3824C10.4807 13.4935 9.68451 14.3982 8.68335 14.3982ZM15.329 14.3982C14.3435 14.3982 13.5316 13.4935 13.5316 12.3824C13.5316 11.2713 14.3278 10.3666 15.329 10.3666C16.338 10.3666 17.1421 11.2793 17.1264 12.3824C17.1264 13.4935 16.338 14.3982 15.329 14.3982Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgDiscord = (SvgDiscord);
;// CONCATENATED MODULE: ./src/svg/SvgGitHub.tsx


function SvgGitHub(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 16.42 4.87 20.17 8.84 21.5C9.34 21.58 9.5 21.27 9.5 21C9.5 20.77 9.5 20.14 9.5 19.31C6.73 19.91 6.14 17.97 6.14 17.97C5.68 16.81 5.03 16.5 5.03 16.5C4.12 15.88 5.1 15.9 5.1 15.9C6.1 15.97 6.63 16.93 6.63 16.93C7.5 18.45 8.97 18 9.54 17.76C9.63 17.11 9.89 16.67 10.17 16.42C7.95 16.17 5.62 15.31 5.62 11.5C5.62 10.39 6 9.5 6.65 8.79C6.55 8.54 6.2 7.5 6.75 6.15C6.75 6.15 7.59 5.88 9.5 7.17C10.29 6.95 11.15 6.84 12 6.84C12.85 6.84 13.71 6.95 14.5 7.17C16.41 5.88 17.25 6.15 17.25 6.15C17.8 7.5 17.45 8.54 17.35 8.79C18 9.5 18.38 10.39 18.38 11.5C18.38 15.32 16.04 16.16 13.81 16.41C14.17 16.72 14.5 17.33 14.5 18.26C14.5 19.6 14.5 20.68 14.5 21C14.5 21.27 14.66 21.59 15.17 21.5C19.14 20.16 22 16.42 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgGitHub = (SvgGitHub);
;// CONCATENATED MODULE: ./src/svg/SvgLightTheme.tsx


function SvgLightTheme(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M12 7C13.3261 7 14.5978 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5978 16.4732 13.3261 17 12 17C10.6739 17 9.40214 16.4732 8.46446 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46446 8.46447C9.40214 7.52678 10.6739 7 12 7ZM12 2L14.39 5.42C13.65 5.15 12.84 5 12 5C11.16 5 10.35 5.15 9.61 5.42L12 2ZM3.34 7L7.5 6.65C6.9 7.16 6.36 7.78 5.94 8.5C5.5 9.24 5.25 10 5.11 10.79L3.34 7ZM3.36 17L5.12 13.23C5.26 14 5.53 14.78 5.95 15.5C6.37 16.24 6.91 16.86 7.5 17.37L3.36 17ZM20.65 7L18.88 10.79C18.74 10 18.47 9.23 18.05 8.5C17.63 7.78 17.1 7.15 16.5 6.64L20.65 7ZM20.64 17L16.5 17.36C17.09 16.85 17.62 16.22 18.04 15.5C18.46 14.77 18.73 14 18.87 13.21L20.64 17ZM12 22L9.59 18.56C10.33 18.83 11.14 19 12 19C12.82 19 13.63 18.83 14.37 18.56L12 22Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgLightTheme = (SvgLightTheme);
// EXTERNAL MODULE: ./src/utils/localUserSettings.ts
var localUserSettings = __webpack_require__(382);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx















function Footer_Footer(_ref) {
  var _ref$hasMargin = _ref.hasMargin,
      hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin;

  var _useState = (0,react.useState)('dark'),
      currentThemeName = _useState[0],
      setCurrentThemeName = _useState[1];

  (0,react.useEffect)(function () {
    setCurrentThemeName((0,localUserSettings/* loadSettings */.r)().theme);
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Footer, {
    hasMargin: hasMargin,
    mobile: {
      '@initial': false,
      '@small': true
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
        children: "\n\t\t\t\t\t\t#theme-settings {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyrightNotice, {
      children: "\xA9 ChatSift, 2022 - Present"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonsAndLinks, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLink, {
          href: "/github",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgGitHub, {
            themeColor: stitches_config/* theme.colors.textDisabled.toString */.rS.colors.textDisabled.toString()
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLink, {
          href: "/support",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgDiscord, {
            themeColor: stitches_config/* theme.colors.textDisabled.toString */.rS.colors.textDisabled.toString()
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SecondGroup, {
        id: "theme-settings",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
          children: "Theme:"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          buttonType: "ghost",
          form: "extraSmall",
          paddingOverride: {
            x: buttonPadding,
            y: buttonPadding
          },
          onPress: function onPress() {
            (0,switchTheme/* setThemeWrapper */.h)(currentThemeName === 'dark' ? 'light' : 'dark');
            setCurrentThemeName(currentThemeName === 'dark' ? 'light' : 'dark');
          },
          children: currentThemeName === 'dark' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgDarkTheme, {
            themeColor: stitches_config/* theme.colors.textPrimary.toString */.rS.colors.textPrimary.toString()
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(svg_SvgLightTheme, {
            themeColor: stitches_config/* theme.colors.textPrimary.toString */.rS.colors.textPrimary.toString()
          })
        })]
      })]
    })]
  });
}

/* harmony default export */ var components_Footer = (Footer_Footer);

/***/ }),

/***/ 1301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2903);




function PageMeta(props) {
  var _props$description;

  var title = props.title;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
      children: title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: title,
      property: "og:title"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "ChatSift",
      property: "og:site_name"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "/assets/chatsift.png",
      property: "og:image"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : 'A powerful solution for your day-to-day moderation bot needs.',
      property: "description"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      name: "theme-color",
      content: "#318EEE"
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);

/***/ }),

/***/ 2123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6556);
/* harmony import */ var _components_ButtonLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4748);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1127);
/* harmony import */ var _components_PageMeta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1301);
/* harmony import */ var _components_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2762);
/* harmony import */ var _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8325);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2903);









var Container = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .zo)('main', {
  displayFlex: 'column',
  flex: '1 0 auto',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_5__/* .theme.space.lg */ .rS.space.lg,
  justifyContent: 'center'
});

function NotFound404() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_PageMeta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      title: "404 Not Found"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(Container, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
        kind: "big",
        weight: "bold",
        color: "primary",
        children: "404"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .z, {
        as: _components_ButtonLink__WEBPACK_IMPORTED_MODULE_1__/* .ButtonLink */ .Z,
        buttonType: "callToAction",
        href: "/",
        children: "Go home"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (NotFound404);

/***/ }),

/***/ 9133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(2123);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);